module.exports = __webpack_public_path__ + "img/affiliate_dark.3e4dde6.svg";